import React from "react";

function CarsForRent() {

  return (
    <section className="cars-for-rent">

      <h1>
        Cars for Rent
      </h1>

      <p>
        Browse vehicles available for rental.
      </p>

    </section>
  );
}

export default CarsForRent;